import { render, staticRenderFns } from "./MoBlockEditor.vue?vue&type=template&id=23724838&"
import script from "./MoBlockEditor.vue?vue&type=script&lang=js&"
export * from "./MoBlockEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports